(function () {
  const hero = document.querySelector('.index-hero');
  if (!hero) return;

  const videos = hero.querySelectorAll('[data-hero-video], .index-hero__bg--video');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function syncVideoPlayback() {
    if (!videos.length) return;

    videos.forEach((el) => {
      if (reduceMotion.matches) {
        el.pause();
        return;
      }

      const playPromise = el.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  }

  if (videos.length) {
    videos.forEach((el) => {
      el.muted = true;
      el.setAttribute('playsinline', '');
    });
    syncVideoPlayback();

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', syncVideoPlayback);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(syncVideoPlayback);
    }
  }

  const robots = hero.querySelectorAll('[data-hero-robot]');
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (canHover && robots.length) {
    robots.forEach((robot) => {
      robot.addEventListener('mouseenter', () => {
        robot.classList.add('is-hovered');
      });

      robot.addEventListener('mouseleave', () => {
        robot.classList.remove('is-hovered');
      });
    });
  }

  const track = hero.querySelector('[data-hero-robots]');
  if (!track || robots.length < 2) return;

  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const AUTO_MS = 3200;
  let timer = null;
  let index = 0;
  let paused = false;

  function stepWidth() {
    const first = robots[0];
    if (!first) return 0;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function goTo(nextIndex, smooth) {
    const width = stepWidth();
    if (!width) return;

    index = ((nextIndex % robots.length) + robots.length) % robots.length;
    track.scrollTo({
      left: index * width,
      behavior: smooth === false || reduceMotion.matches ? 'auto' : 'smooth',
    });
  }

  function stopAuto() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function startAuto() {
    stopAuto();
    if (!mobileQuery.matches || reduceMotion.matches || paused) return;

    timer = window.setInterval(() => {
      goTo(index + 1, true);
    }, AUTO_MS);
  }

  function pauseTemporarily() {
    paused = true;
    stopAuto();
    window.clearTimeout(pauseTemporarily._t);
    pauseTemporarily._t = window.setTimeout(() => {
      paused = false;
      startAuto();
    }, 5000);
  }

  function onManualScroll() {
    const width = stepWidth();
    if (!width) return;
    index = Math.round(track.scrollLeft / width) % robots.length;
  }

  track.addEventListener('pointerdown', pauseTemporarily, { passive: true });
  track.addEventListener('touchstart', pauseTemporarily, { passive: true });
  track.addEventListener('wheel', pauseTemporarily, { passive: true });
  track.addEventListener('scroll', onManualScroll, { passive: true });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', () => {
      if (mobileQuery.matches) {
        goTo(0, false);
        startAuto();
      } else {
        stopAuto();
        track.scrollTo({ left: 0, behavior: 'auto' });
        index = 0;
      }
    });
  }

  if (mobileQuery.matches) {
    startAuto();
  }
})();
